import React from 'react'

import { Button } from '@/ui/button'
import { MintField as Field } from '../../domain/liquidity'
import { ApprovalState } from '../../hooks/useApproveCallback'
import type { AddLiquidityControllerResult } from '../../features/liquidity/useAddLiquidityController'

export function AddLiquidityActionBar({ controller }: { controller: AddLiquidityControllerResult }) {
  const {
    account,
    approvalA,
    approvalB,
    approveACallback,
    approveBCallback,
    currencies,
    error,
    handleSupplyAction,
    isValid,
    openConnectModal,
    parsedAmounts,
  } = controller

  if (!account) {
    return (
      <Button type="button" className="h-11 w-full" variant="secondary" onClick={openConnectModal}>
        Connect Wallet
      </Button>
    )
  }

  const needsApproval =
    isValid &&
    (approvalA === ApprovalState.NOT_APPROVED ||
      approvalA === ApprovalState.PENDING ||
      approvalB === ApprovalState.NOT_APPROVED ||
      approvalB === ApprovalState.PENDING)

  const bothApproved = approvalA === ApprovalState.APPROVED && approvalB === ApprovalState.APPROVED
  const hasAmounts = Boolean(parsedAmounts[Field.CURRENCY_A] && parsedAmounts[Field.CURRENCY_B])
  const showError = !isValid && hasAmounts

  return (
    <div className="flex flex-col gap-3">
      {needsApproval ? (
        <div className="flex gap-2">
          {approvalA !== ApprovalState.APPROVED ? (
            <Button
              type="button"
              className="h-11 flex-1"
              variant="outline"
              disabled={approvalA !== ApprovalState.NOT_APPROVED}
              onClick={approveACallback}
            >
              {approvalA === ApprovalState.UNKNOWN
                ? 'Loading allowance'
                : approvalA === ApprovalState.PENDING
                  ? `Approving ${currencies[Field.CURRENCY_A]?.symbol ?? ''}…`
                  : `Approve ${currencies[Field.CURRENCY_A]?.symbol ?? ''}`}
            </Button>
          ) : null}
          {approvalB !== ApprovalState.APPROVED ? (
            <Button
              type="button"
              className="h-11 flex-1"
              variant="outline"
              disabled={approvalB !== ApprovalState.NOT_APPROVED}
              onClick={approveBCallback}
            >
              {approvalB === ApprovalState.UNKNOWN
                ? 'Loading allowance'
                : approvalB === ApprovalState.PENDING
                  ? `Approving ${currencies[Field.CURRENCY_B]?.symbol ?? ''}…`
                  : `Approve ${currencies[Field.CURRENCY_B]?.symbol ?? ''}`}
            </Button>
          ) : null}
        </div>
      ) : null}
      <Button
        type="button"
        className="h-11 w-full text-base"
        variant={showError ? 'destructive' : 'default'}
        disabled={!isValid || !bothApproved}
        onClick={handleSupplyAction}
      >
        {error ?? 'Supply'}
      </Button>
    </div>
  )
}
